import { useWellbeingContext } from '../../../core/context/WellbeingContext';
import Header from '../../../components/Header/Header';
import Banner from '../../../components/Banner/Banner';
import SubcategoriesList from '../../../components/SubcategoriesList/SubcategoriesList';
import ArticleList from '../../../components/ArticleList/ArticleList';
import VideoSlider from '../../../components/VideoSlider/VideoSlider';
import {
  StyledPageContainer,
  StyledPageContent,
  StyledPageMainContent,
  StyledPageMainSidebar,
} from '../../../styles/config/pageStyle';

function Wellbeing() {
  const { banner, subcategories, articles, videos } = useWellbeingContext();

  return (
    <>
      <Header />
      <Banner data={banner} />

      <StyledPageContainer>
        <StyledPageContent>
          <StyledPageMainContent>
            <SubcategoriesList listData={subcategories} />
          </StyledPageMainContent>
        </StyledPageContent>
      </StyledPageContainer>

      <StyledPageContainer>
        <StyledPageContent reverse>
          <StyledPageMainSidebar>
            <VideoSlider data={videos} />
          </StyledPageMainSidebar>

          <StyledPageMainContent>
            <ArticleList articles={articles} />
          </StyledPageMainContent>
        </StyledPageContent>
      </StyledPageContainer>
    </>
  );
}

export default Wellbeing;
